import { render, staticRenderFns } from "./WarningModal4.vue?vue&type=template&id=148e73c4&scoped=true"
import script from "./WarningModal4.vue?vue&type=script&lang=js"
export * from "./WarningModal4.vue?vue&type=script&lang=js"
import style0 from "./WarningModal4.vue?vue&type=style&index=0&id=148e73c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e73c4",
  null
  
)

export default component.exports